module.exports = __webpack_public_path__ + "img/traffic-light-solid.7411770a.png";